<template>
  <div id="ipo3_login">
    <div class="login_from">
      <div class="title">
        <!-- <img src="images/mobile_admin_iphone.png" /> -->
        <span>{{ $t('login.title') }}</span>
      </div>

      <p>
        <span>{{ $t('login.tip') }}</span>
      </p>
      <el-form ref="form" :model="user">
        <el-form-item>
          <el-input v-model="user.username" :placeholder="$t('login.username')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="user.password" :placeholder="$t('login.userpwd')" type="password"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">{{ $t('login.btn') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="login_bottom">
      {{ $t('login.bottom') }}
    </div>
  </div>
</template>

<script>
import { setToken } from "../../config/cache";
import { setAppTitle } from "../../config/appTitle";

export default {
  name: "login",
  data() {
    return {
      user: {
        username: "",
        password: ""
      }
    };
  },

  methods: {
    onSubmit() {
      const self = this;

      this.$http.post("/admin/index/login", this.user).then(res => {
        console.log("code:", res.code);
        if (res.code == 200) {
          const user = res.data.user || {};
          const year = res.data.currentYear || res.data.current_year || res.data.lunarYear || res.data.lunar_year || res.data.year;
          if (year && !user.currentYear) {
            user.currentYear = parseInt(year);
          }
          self.$store.dispatch("user/saveUserInfo", user);
          const token = res.data.token;
          setToken(token); //保存token
          setAppTitle(user);
          console.log("user:", user)
          if (user.username == "admin" || user.username == "terry") {
            self.$router.push({ path: "/items", query: { name: user.username } });
          } else {
            self.$router.push({ path: "/xzt", query: { name: user.username } });

          }
        } else {
          self.$message.error(res.msg);
        }
      });
    },

  }
};
</script>

<style lang="less">
#ipo3_login {
  background: #326fea;
  background: -webkit-linear-gradient(to right, #326fea, #2699f5);
  background: linear-gradient(to right, #326fea, #2699f5);
  height: 100%;

  .login_bottom {
    height: 50px;
    position: fixed;
    width: 100%;
    // background:#999;
    bottom: 0;
    line-height: 50px;
    color: white;
  }

  .login_from {
    width: 400px;
    box-sizing: border-box;
    height: 460px;
    background: white;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    padding: 50px;
    border-radius: 10px;
    text-align: left;

    .title {
      line-height: 50px;
      font-size: 1.5rem;
      font-weight: bold;

      img {
        height: 50px;
      }

      img,
      span {
        vertical-align: middle;
      }
    }

    p {
      color: #2699f5;
      font-weight: bold;
      line-height: 40px;
      height: 40px;

      span {
        border-bottom: 1px solid #2699f5;
      }
    }

    /deep/.el-button {
      width: 100%;
    }
  }
}</style>